export var pt_br = {
    required: 'Obrigatório',
    deprecated: 'Obsoleto',
    deprecated_and_sunset_on: 'Esta operação está obsoleta e será descontinuada em ${1}.',
    stability_experimental: 'Experimental',
    stability_alpha: 'Alfa',
    stability_beta: 'Beta',
    copy_to_clipboard: 'Copiar para a área de transferência',
    copied: 'Copiado',
    no_content: 'Sem conteúdo',
    unresolved_reference: 'Referência não resolvida',
    circular_reference: 'Referência circular',
    read_only: 'Somente leitura',
    write_only: 'Somente escrita',
    optional: 'Opcional',
    min: 'Mín',
    max: 'Máx',
    nullable: 'Nulo',
    body: 'Corpo',
    payload: 'Carga útil',
    headers: 'Cabeçalhos',
    authorizations: 'Autorizações',
    responses: 'Respostas',
    path_parameters: 'Parâmetros de rota',
    query_parameters: 'Parâmetros de consulta',
    header_parameters: 'Parâmetros de cabeçalho',
    attributes: 'Atributos',
    test_it: 'Testar',
    information: 'Informação',
    success: 'Sucesso',
    redirect: 'Redirecionamento',
    error: 'Erro',
    show: 'Mostrar',
    hide: 'Ocultar',
    available_items: 'Itens disponíveis',
    child_attributes: 'Atributos filhos',
};
